export default __webpack_public_path__ + "static/media/ic_add_icon_yellow.564786ed.svg";